import ConsumerHeader from './ConsumerHeader';
import withStickyBehavior from './withStickyBehavior';

export default withStickyBehavior(ConsumerHeader);
